import { ref, onMounted, onUnmounted } from 'vue'

// Utility function to detect if the device is mobile
export function isMobileDevice() {
  // Check if we're in a browser environment
  if (typeof window === 'undefined') return false
  
  // Check for mobile user agent
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  
  // Mobile device detection patterns
  const mobilePatterns = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ]
  
  // Check if user agent matches any mobile pattern
  const isMobileUA = mobilePatterns.some(pattern => pattern.test(userAgent))
  
  // Additional check for touch capability (more reliable for modern devices)
  const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0
  
  // Check screen size (mobile typically < 768px)
  const isSmallScreen = window.innerWidth < 768
  
  // Return true if any mobile indicator is present
  return isMobileUA || (hasTouchScreen && isSmallScreen)
}

// Reactive mobile detection for Vue components
export function useMobileDetection() {
  const isMobile = ref(false)
  
  const updateMobileStatus = () => {
    isMobile.value = isMobileDevice()
  }
  
  onMounted(() => {
    updateMobileStatus()
    window.addEventListener('resize', updateMobileStatus)
  })
  
  onUnmounted(() => {
    window.removeEventListener('resize', updateMobileStatus)
  })
  
  return { isMobile }
} 